import PropTypes from 'prop-types';


export default PropTypes.oneOfType([
    PropTypes.array,        // Needed to support resolved results of react-intl which contain markup
    PropTypes.string,       // Raw content
    PropTypes.node,         // Expected to be a <FormattedMessage>
    PropTypes.shape({       // Message descriptor, expected to be pulled from a defineMessages result
        id: PropTypes.string.isRequired,
        description: PropTypes.string,
        defaultMessage: PropTypes.string,
    }),
    PropTypes.shape({       // Custom descriptor + values object.
        descriptor: PropTypes.shape({
            id: PropTypes.string.isRequired,
            description: PropTypes.string,
            defaultMessage: PropTypes.string,
        }).isRequired,
        values: PropTypes.object,
    }),
]);
